import React from 'react';
import './avatar.scss';

const Avatar = ({
  mediaUrl,
  altText = 'Avatar',
  name = '',
  customStyle = {},
  setShowProfileDetails,
  width = '100%',
  height = '100%',
  fontSize = '24px',
  hover = true,
}) => {
  const getInitials = () =>
    name
      .split(' ')
      .map((part) => part[0])
      .join('')
      .toUpperCase();

  const handleClick = () => {
    if (setShowProfileDetails) {
      setShowProfileDetails(true);
    }
  };

  return (
    <div
      className={`avatar-container ${hover ? 'hover-enabled' : 'no-hover'}`}
      style={{ ...customStyle, width, height, fontSize }}
      onClick={handleClick}
    >
      {mediaUrl ? (
        <img className="avatar-image" src={mediaUrl} alt={altText} />
      ) : (
        getInitials()
      )}
    </div>
  );
};

export default Avatar;
